import { ApiService } from "./api.service";
export default class ImportantDatesService extends ApiService {
  namespace = "WeatherForecast";
  template = "importantDatesTemplate";
  DOMAIN = 14;
  icon = "BlockWithSun";
  name = "WeatherForecast";
  constructor() {
    super("events/important-dates");
  }
}
